<template>
  <!--
    Teleport to body so temporary sidebars escape v-dialog / table stacking
    contexts (same idea as Vuetify 2 app-level fixed drawers).
  -->
  <Teleport to="body">
    <v-navigation-drawer
      class="base-sidebar"
      :model-value="drawerOpen"
      :width="width"
      location="end"
      :temporary="temporary"
      v-bind="forwardedAttrs"
      @update:model-value="setOpen"
    >
      <template #prepend>
        <base-sidebar-viewer-btn
          icon="mdi-close"
          label="Close"
          btn-class="mt-2 background"
          icon-color="grey"
          class="position-absolute"
          style="top: 8px; right: 8px; z-index: 1;"
          @click="setOpen(false)"
        />
      </template>
      <slot />
    </v-navigation-drawer>
  </Teleport>
</template>

<script>
export default {
  name: 'BaseSidebar',

  inheritAttrs: false,

  props: {
    modelValue: {},
    value: {},
    width: {
      type: [Number, String],
      default: 350,
    },
    temporary: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['update:modelValue', 'input'],

  computed: {
    drawerOpen() {
      return !!(this.modelValue ?? this.value);
    },

    forwardedAttrs() {
      const attrs = { ...this.$attrs };
      delete attrs.fixed;
      delete attrs.right;
      delete attrs.temporary;
      return attrs;
    },
  },

  methods: {
    setOpen(open) {
      this.$emit('update:modelValue', open);
      this.$emit('input', open);
    },
  },
};
</script>

<style>
/*
 * Nested temporary drawers use absolute layout in V3. Force viewport-fixed
 * placement above dialogs (default overlay z-index 2400).
 */
.base-sidebar.v-navigation-drawer--temporary {
  position: fixed !important;
  top: 0 !important;
  bottom: 0 !important;
  height: 100% !important;
  z-index: 2501 !important;
}

.base-sidebar.v-navigation-drawer--temporary + .v-navigation-drawer__scrim {
  position: fixed !important;
  inset: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 2500 !important;
}

/*
 * Select/menu overlays teleport to body at ~2000–2400 and would sit under the
 * drawer. While a base-sidebar is open, raise only menu overlays (not dialogs).
 */
body:has(.base-sidebar.v-navigation-drawer--temporary.v-navigation-drawer--active) .v-overlay.v-menu {
  z-index: 2700 !important;
}
</style>
